'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp, _class$propTypes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wrapClass = require('../utils/wrapClass');

var _wrapClass2 = _interopRequireDefault(_wrapClass);

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Overlay
 * @author terencewu
 */


var publicMethodMap = ['isVisible', 'show', 'hide'];
var Overlay = (_temp = _class = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props) {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
  }

  _createClass(Overlay, [{
    key: 'getInstanceFromComponent',
    value: function getInstanceFromComponent(component) {
      return component.label;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          customConstructor = _props.customConstructor,
          constructorParams = _props.constructorParams,
          initialize = _props.initialize,
          draw = _props.draw;
      var CustomOverlayClass = this.getOverlayClass(customConstructor, initialize, draw);
      this.overlay = new CustomOverlayClass(constructorParams); // eslint-disable-line no-undef

      this.props[_constants.MAP].addOverlay(this.overlay);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      if (children) {
        return _react2.default.createElement('div', null, children);
      }

      return false;
    }
  }, {
    key: 'getOverlayClass',
    value: function getOverlayClass(customConstructor, _initialize, _draw) {
      var _class2, _temp2;

      return _temp2 = _class2 = function (_BMap$Overlay) {
        _inherits(CustomOverlay, _BMap$Overlay);

        function CustomOverlay(params) {
          _classCallCheck(this, CustomOverlay);

          var _this2 = _possibleConstructorReturn(this, (CustomOverlay.__proto__ || Object.getPrototypeOf(CustomOverlay)).call(this));

          if (customConstructor) {
            customConstructor(_this2, params);
          }

          return _this2;
        } // eslint-disable-line


        _createClass(CustomOverlay, [{
          key: 'initialize',
          value: function initialize(map) {
            if (_initialize) {
              _initialize(this, map);
            }
          }
        }, {
          key: 'draw',
          value: function draw() {
            if (_draw) {
              _draw(this);
            }
          }
        }]);

        return CustomOverlay;
      }(BMap.Overlay), _class2.displayName = 'CustomOverlay', _temp2;
    }
  }]);

  return Overlay;
}(_react2.default.Component), _class.propTypes = (_class$propTypes = {}, _defineProperty(_class$propTypes, _constants.MAP, _propTypes2.default.object), _defineProperty(_class$propTypes, 'customConstructor', _propTypes2.default.func), _defineProperty(_class$propTypes, 'constructorParams', _propTypes2.default.object), _defineProperty(_class$propTypes, 'initialize', _propTypes2.default.func), _defineProperty(_class$propTypes, 'draw', _propTypes2.default.func), _class$propTypes), _temp);
exports.default = (0, _wrapClass2.default)(Overlay, null, null, publicMethodMap);
module.exports = exports['default'];